import { derived, writable } from 'svelte/store';
import { getLocalStorage, removeLocalStorage, setLocalStorage } from './utils/local-storage';
import { browser } from '$app/environment';
import { CountryCode } from '$gql/storefront/schemas';
import type { Readable } from '@square/svelte-store';
import { page } from '$app/stores';
import data from '$lib/region/data.json';

const LOCAL_STORAGE_KEY = 'hh-optimal-us-county' as const;

export const SUPPORTED_US_REGION_COUNTRIES = ['CA', 'AU', 'US'] as const;

export type SupportedUSCountries = (typeof SUPPORTED_US_REGION_COUNTRIES)[number];

export const isSupportedUSCountry = (country: string): country is SupportedUSCountries =>
  ([...SUPPORTED_US_REGION_COUNTRIES] as string[]).includes(country);

export const optimalUSCountry = writable(getLocalStorage(LOCAL_STORAGE_KEY), (set) => {
  if (browser) {
    const onStorageEvent = (e: StorageEvent) => {
      if (e.key === LOCAL_STORAGE_KEY) {
        if (e.newValue && isSupportedUSCountry(e.newValue)) {
          set(e.newValue);
        } else {
          set(null);
        }
      }
    };
    window.addEventListener('storage', onStorageEvent);
    return () => window.removeEventListener('storage', onStorageEvent);
  }
});

export const showLangSwitcher: Readable<boolean> = derived([page], ([$page]) => {
  const regionLanguages =
    data[$page.params.region.toLowerCase() as keyof typeof data]?.languages || [];
  return regionLanguages.length > 1;
});

optimalUSCountry.subscribe(($country) => {
  if ($country && isSupportedUSCountry($country)) setLocalStorage(LOCAL_STORAGE_KEY, $country);
  else removeLocalStorage(LOCAL_STORAGE_KEY);
});

export const parseCountryAsCode = (country: string | null | undefined) => {
  if (country && ([...Object.values(CountryCode)] as string[]).includes(country))
    return country as CountryCode;
};
